// Tracks recently served by "Ton DJ" so relaunching it (or the homepage
// preview tile) doesn't keep resurfacing the same songs — the backend
// already excludes whatever's passed here, this just remembers it across
// separate "Lancer" clicks and page reloads instead of resetting every time.
const KEY = "sl.djHistory";
const MAX = 300;

export function getDjHistory(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch { return []; }
}

export function addDjHistory(ids: string[]) {
  if (!ids.length) return;
  try {
    const cur = getDjHistory();
    const seen = new Set(cur);
    const next = [...cur, ...ids.filter((id) => !seen.has(id))].slice(-MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* ignore */ }
}
